import fetch from '../config/fetch'
import ajax from '../config/ajax'
import {getStore} from '../config/mUtils'

export const test = () => fetch('/api/getSceneInfo');


export const test2 = () => fetch('/api/loan/list?page=1&pageSize=8',{},'POST');




/**
 * 登录  http://api.anxin180.com/p2p-mgt/login?uname=admin&upwd=111111  POST
 */
// http://api.anxin180.com/mgt/login?uname=zms&upwd=123456

export const login = (opt) => fetch(`/upms/mgt/pwd?uname=${opt.uname}&upwd=${opt.upwd}`,opt,'POST');


//根据用户名获取资源菜单列表
export const getResource = (opt) => fetch(`/upms/resource/detail`,{},'POST');

//获取全部菜单
export const getAllResource = (opt) => fetch(`/upms/resource/getAllResource`,opt,'GET');


//添加菜单
export const addResource = (opt) => fetch(`/upms/resource/addTreeInfoByResource?${joinStr(opt)}`,opt,'POST');

//修改菜单
export const updateResource = (opt) => fetch(`/upms/resource/updateResource?${joinStr(opt)}`,opt,'POST');

//逻辑删除菜单
export const disableResource = (opt) => fetch(`/upms/resource/disableResource?${joinStr(opt)}`,opt,'POST');



//获取角色列表
export const getRoleList = () => fetch(`/upms/role/getRoleList`,{},'GET');

//根据角色id获取资源以及对应的权限
export const getResourceByRole = (opt) => fetch(`/upms/resource/getResourceByRole?roleId=${opt.rid}`,{},'GET');


//修改角色对应的资源和权限
export const updateRelation = (opt) => fetch(`/upms/role/updateRelation?${joinStr(opt)}`,opt,'POST');




/**
 * 退出登录  http://api.anxin180.com:80/p2p-mgt/logout  POST
 */

export const logout = (opt) => fetch(`/upms/loginOut?token=${opt.token}`,opt,'POST');



//资金流水
export const moneyRecord = (opt) => fetch(`/mgt/capital/list?pageNum=${opt.pageNum}&pageSize=${opt.pageSize}`,{},'GET');

//充值管理
export const recharge = (opt) => fetch(`/mgt/capital/recharge/list?pageNum=${opt.pageNum}&pageSize=${opt.pageSize}&userInfo=${opt.userInfo}&flag=${opt.flag}`,{},'GET');


//提现管理
export const withDraw = (opt) => fetch(`/mgt/capital/withdraw/list?pageNum=${opt.pageNum}&pageSize=${opt.pageSize}&userInfo=${opt.userInfo}&status=${opt.status}`,{},'GET');

//用户个人基本信息
export const userBaseInfo = (opt) => fetch(`/mgt/user/query/baseinfo?searchType=${opt.searchType}&userInfo=${opt.userId}`,{},'GET');

//投资者或借款者列表  1 投资者 2 借款者
export const investList = (opt) => fetch(`/mgt/user/query/list`,opt,'GET');

//获取借款者个人信息
export const userPersonalInfo = (opt) => fetch(`/mgt/user/query/personalinfo?userId=${opt.userId}`,{},'GET');

//用户工作信息
export const userWorkInfo = (opt) => fetch(`/mgt/user/query/workinfo?userId=${opt.userId}`,{},'GET');

//获取借款者财务信息
export const userFinancialInfoApi = (opt) => fetch(`/mgt/user/query/financialinfo?userId=${opt.userId}`,{},'GET');

//开标管理列表
export const waitForOpen = (opt) => fetch(`/mgt/loanmanage/query/waitforopen/loanpage?pageNum=${opt.pageNum}&pageSize=${opt.pageSize}`,{},'GET');

//发标管理列表
export const verifyLoanpage = (opt) => fetch(`/mgt/loanmanage/query/verifying/loanpage?pageNum=${opt.pageNum}&pageSize=${opt.pageSize}`,{},'GET');



//投标中管理列表
export const tendering = (opt) => fetch(`/mgt/loanmanage/query/tendering/loanpage?pageNum=${opt.pageNum}&pageSize=${opt.pageSize}`,{},'GET');


//满标管理列表
export const fullLoan = (opt) => fetch(`/mgt/loanmanage/query/fulloan/page?pageNum=${opt.pageNum}&pageSize=${opt.pageSize}`,{},'GET');


//获取标的概要信息-标详情todo
export const loanDetail = (opt) => fetch(`/mgt/loanmanage/query/loandetail/${opt.loanId}`,{},'GET');


//获取借款人详情-标详情
export const borrowerDetail = (opt) => fetch(`/mgt/user/query/detail?userId=${opt.userId}`,{},'GET');


//获取借款人资产信息-标详情 todo
export const houseAndCarInfo = (opt) => fetch(`/mgt/borrow/query/houseandcar/info?loanId=${opt.loanId}`,{},'GET');

//通过标Id获取该标中用户的认证材料（包括房产证，身份证明，企业证照，不包括借款协议）-标详情 todo
export const borrowerMaterial = (opt) => fetch(`/mgt/borrow/query/borrowermaterial?loanId=${opt.loanId}&pawnType=${opt.pawnType}`,{},'GET');


//获取该标的材料照片(如借款协议） /mgt/borrow/query/creditmaterial
export const creditmaterial = (loanId) => fetch(`/mgt/borrow/query/creditmaterial?loanId=${loanId}`,{},'GET');


//进入申请贷款页面
export const goBorrowPageApi = (opt) => fetch(`/mgt/borrow/goto/borrowpage?searchType=${opt.searchType}&userInfo=${opt.userInfo}`,{},'GET');

//获取代偿人信息  /mgt/borrow/query/compensationList
export const compensationList = (opt) => fetch(`/mgt/borrow/query/compensation/list`,opt,'GET');

//保存提交的贷款申请信息  /mgt/borrow/addLoanInfo
export const addLoanInfo = (opt) => fetch(`/mgt/borrow/add/loaninfo`,opt,'POST');

//获取描述房产、车辆的信息    返回CreditDef的map，如1代表普通商品房，2代表经济适用房...    /mgt/borrow/getCreditDef
export const getCreditDef = (opt) => fetch(`/mgt/borrow/getcreditdef`,{},'GET');

//增加借款人车辆信息  /mgt/borrow/save/carInfo/{userId}
export const setCarInfo = (opt,userId) => fetch(`/mgt/borrow/save/carinfo?userId=${userId}`,opt,'POST');

//增加借款人房产信息  /mgt/borrow/save/houseInfo/{userId}
export const setHouseInfo = (opt,userId) => fetch(`/mgt/borrow/save/houseinfo?userId=${userId}`,opt,'POST');



//获取借款人车辆信息 /mgt/borrow/query/cars/{userId}
export const getCars = (userId) => fetch(`/mgt/borrow/query/cars?userId=${userId}`,{},'GET');


//获取借款人房产信息 /mgt/borrow/query/houses/{userId}
export const getHouses = (userId) => fetch(`/mgt/borrow/query/houses?userId=${userId}`,{},'GET');


//删除借款人房产信息 /mgt/borrow/delete/houseInfo/{houseId}
export const delHouses = (houseId) => fetch(`/mgt/borrow/delete/houseinfo?houseId=${houseId}`,{},'DELETE');


//删除借款人车辆信息 /mgt/borrow/delete/carInfo/{carId}
export const delCar = (carId) => fetch(`/mgt/borrow/delete/carinfo?carId=${carId}`,{},'DELETE');


//获取借款人房产对应的房产证 /mgt/borrow/query/houseMaterial/{houseId}
export const houseMaterial = (houseId) => fetch(`/mgt/borrow/query/housematerial?houseId=${houseId}`,{},'GET');



//获取用户的企业信息 /mgt/borrow/query/houses/{userId}
export const getUserMerchantInfo = (userId) => fetch(`/mgt/user/query/merchantinfo?userId=${userId}`,{},'GET');


//获取借款者的个人信息 /mgt/user/query/userPersonalInfo/{userId}
export const getUserPersonalInfo = (userId) => fetch(`/mgt/user/query/personalinfo?userId=${userId}`,{},'GET');

//录标最后一步
export const setstatusSubmit = (loanId) => fetch(`/mgt/borrow/setstatus/onsubmit?loanId=${loanId}`,{},'PUT');



//获取企业营业执照  /mgt/borrow/query/merchantMaterial/{userMerchantInfoId}
export const getMerchantMaterial = (userId) => fetch(`/mgt/borrow/query/merchantmaterial?userMerchantInfoId=${userId}`,{},'GET');


//增加借款人个人信息 /mgt/borrow/save/personalInfo/toLoanPawn
export const setPersonalInfo = (opt,userId) => fetch(`/mgt/user/query/personalinfo?userId=${userId}`,opt,'POST');

//增加借款人企业信息  /mgt/borrow/save/merchantInfo/toLoanPawn todo
export const setMerchantInfo = (opt,userId) => fetch(`/mgt/borrow/save/merchantInfo/toLoanPawn/${userId}`,opt,'POST');


//删除认证材料  /mgt/borrow/delete/borrowerMaterial/{id}
export const delMerchantInfo = (id) => fetch(`/mgt/borrow/delete/borrowermaterial?id=${id}`,{},'PUT');


//获取借款者的身份证件  /mgt/borrow/query/idCardMaterial/{userPersonalInfoId}
export const getIdCardMaterial = (id) => fetch(`/mgt/borrow/query/idcardmaterial?userPersonalInfoId=${id}`,{},'GET');


//获取借款人房产对应的房产证  /mgt/borrow/query/houseMaterial/{userPersonalInfoId}
export const getHouseMaterial = (id) => fetch(`/mgt/borrow/query/housematerial?houseId=${id}`,{},'GET');


//保存企业信息到标的资产中，与标建立关联关系  /mgt/borrow/save/merchantInfo/toLoanPawn
export const connectMerchantInfo = (opt) => fetch(`/mgt/borrow/save/merchantinfo/toloanpawn?loanId=${opt.loanId}&userMerchantInfoId=${opt.userMerchantInfoId}`,opt,'POST');

//保存房产信息到标的资产中，与标建立关联关系  
export const houseinfoToloanpawnApi = (opt) => fetch(`/mgt/borrow/save/houseinfo/toloanpawn?loanId=${opt.loanId}&houseId=${opt.houseId}`,opt,'POST');

//保存车辆信息到标的资产中，与标建立关联关系  
export const carinfoToloanpawnApi = (opt) => fetch(`/mgt/borrow/save/carinfo/toloanpawn?loanId=${opt.loanId}&carId=${opt.carId}`,opt,'POST');



//保存个人信息到标的资产中，与标建立关联关系  /mgt/borrow/save/personalInfo/toLoanPawn
export const connectPersonalInfo = (opt) => fetch(`/mgt/borrow/save/personalinfo/toloanpawn?loanId=${opt.loanId}&userPersonalInfoId=${opt.userPersonalInfoId}`,opt,'POST');

//获取联系人信息  /mgt/user/query/contact
export const contactInfoApi = (opt) => fetch(`/mgt/user/query/contact?borrowerId=${opt.borrowerId}`,{},'GET');



//等待初审列表
export const waitingLoanpage= (opt) => fetch(`/mgt/loanmanage/query/firstverify/waiting/loanpage`,opt,'GET');

//初审中列表
export const firstverifyingLoanpage= (opt) => fetch(`/mgt/loanmanage/query/firstverifying/loanpage`,opt,'GET');

//初审拒绝列表
export const rejectedLoanpage= (opt) => fetch(`/mgt/loanmanage/query/firstverify/rejected/loanpage`,opt,'GET');

//等待复审列表
export const waitingReview= (opt) => fetch(`/mgt/loanmanage/query/secondverify/waiting/loanpage`,opt,'GET');

//待开标复审列表
export const waitforopenReview= (opt) => fetch(`/mgt/loanmanage/query/waitforopen/loanpage`,opt,'GET');

//初审中列表
export const secondverifyingReview= (opt) => fetch(`/mgt/loanmanage/query/secondverifying/loanpage`,opt,'GET');

//初审拒绝列表
export const rejectedReview= (opt) => fetch(`/mgt/loanmanage/query/secondverify/rejected/loanpage`,opt,'GET');


//审批历史
export const auditrecord= (opt) => fetch(`/mgt/loanaudit/query/auditrecord`,opt,'GET');



//更新、修改标概要信息
export const loansummaryinfo= (opt) => fetch(`/mgt/loanmanage/update/loansummaryinfo`,opt,'POST');


//通过初审
export const passFirstverify= (opt,auditComment) => fetch(`/mgt/loanaudit/pass/firstverify?auditComment=${auditComment}`,opt,'POST');


//初审拒绝
export const rejectFirstverify= (opt,auditComment) => fetch(`/mgt/loanaudit/reject/firstverify?auditComment=${auditComment}&loanId=${opt.loanId}`,opt,'POST');

//通过复审
export const passSecondverify= (opt,auditComment) => fetch(`/mgt/loanaudit/pass/secondverify?auditComment=${auditComment}`,opt,'POST');


//复审拒绝
export const rejectSecondverify= (opt,auditComment) => fetch(`/mgt/loanaudit/reject/secondverify?auditComment=${auditComment}&loanId=${opt.loanId}`,opt,'POST');


//打回初审
export const pushbackFirstverify= (opt,auditComment) => fetch(`/mgt/loanaudit/pushback/tofirstverify?auditComment=${auditComment}&loanId=${opt.loanId}`,opt,'POST');



//上传用户的认证材料
// export const borrowerUpload= (opt) => fetch(`/mgt/borrow/upload/borrowermaterial?`,opt,'POST');


//检查是否有未审核状态的认证资料 /mgt/loanaudit/check/imagelist
export const checkImagelist= (loanId) => fetch(`/mgt/loanaudit/check/imagelist?loanId=${loanId}`,{},'GET');



//发标审核-确定审核**标  /mgt/loanaudit/checkloan/beforeverify
export const checkloan= (loanId) => fetch(`/mgt/loanaudit/checkloan/beforeverify?loanId=${loanId}`,{},'POST');


//发标打回 
export const rejectSubmitloan= (loanId,auditComment) => fetch(`/mgt/loanaudit/reject/submitloan?loanId=${loanId}&auditComment=${auditComment}`,{},'POST');


//投资列表
export const investorlist= (opt) => fetch(`/mgt/loaninvestor/query/investorlist?loanId=${opt.loanId}&pageNum=${opt.pageNum}&pageSize=${opt.pageSize}`,{},'GET');


//审核页面影像件查询
export const queryMaterial= (loanId) => fetch(`/mgt/borrow/query/material?loanId=${loanId}`,{},'GET');

//影像件审核提交-批量审核用户认证资料材料照片
export const borrowermaterialState= (opt) => fetch(`/mgt/loanaudit/update/borrowermaterial/state?ids=${opt.ids}&type=${opt.type}`,{},'POST');

//删除用户认证材料的马赛克图片
export const deletemMsaicBorrowermaterial= (borrowerMaterialId) => fetch(`/mgt/borrow/delete/mosaic/borrowermaterial?borrowerMaterialId=${borrowerMaterialId}`,{},'PUT');

//上传用户认证材料的马赛克图片
//export const mosaicBorrowermaterial= (borrowerMaterialId) => fetch(`/mgt/borrow/upload/mosaic/borrowermaterial?borrowerMaterialId=${borrowerMaterialId}`,{},'POST');


//影像件审核提交-批量审核标的材料照片
export const creditmaterialState= (opt) => fetch(`/mgt/loanaudit/update/creditmaterial/state?ids=${opt.ids}&type=${opt.type}`,{},'POST');


//删除用户认证材料的马赛克图片
export const deletemMsaicCreditmaterial= (creditMaterialId) => fetch(`/mgt/borrow/delete/mosaic/creditmaterial?creditMaterialId=${creditMaterialId}`,{},'PUT');

// //删除用户认证材料的马赛克图片
// export const compensationList= () => fetch(`/mgt/borrow/query/compensation/list`,{},'GET');


//获取投资人列表（录标和审核时vip标指定投资人时调用）
export const usersInvestorrole= (loanId,mobile) => fetch(`/mgt/borrow/query/users/investorrole?loanId=${loanId}&mobile=${mobile}`,{},'GET');

//获取投资人列表（录标和审核时vip标指定投资人时调用）
export const usersInvestorrole2= (opt) => fetch(`/mgt/borrow/query/users/investorrole`,opt,'GET');

//给vip标分配投资人
export const manageInvestors= (loanId,userIds) => fetch(`/mgt/loanaudit/manage/investors?loanId=${loanId}&userIds=${userIds}`,{},'POST');



//还款完成列表
export const closedLoanpage = (opt) => fetch(`/mgt/loanmanage/query/closed/loanpage?pageNum=${opt.pageNum}&pageSize=${opt.pageSize}`,{},'GET');


//还款中列表
export const repayLoanpage = (opt) => fetch(`/mgt/loanmanage/query/repaying/loanpage?pageNum=${opt.pageNum}&pageSize=${opt.pageSize}`,{},'GET');



//采集中列表
export const applyLoanpage = (opt) => fetch(`/mgt/loanmanage/query/applying/loanpage?pageNum=${opt.pageNum}&pageSize=${opt.pageSize}`,{},'GET');


//逾期列表
export const overdueLoanpage = (opt) => fetch(`/mgt/loanmanage/query/overdue/loanpage?pageNum=${opt.pageNum}&pageSize=${opt.pageSize}`,{},'GET');

//流标列表
export const killloan = (opt) => fetch(`/mgt/loanmanage/query/killloan/page?pageNum=${opt.pageNum}&pageSize=${opt.pageSize}`,{},'GET');


//开标
export const openLoanApi = (opt) => fetch(`/mgt/loan/open?loanId=${opt.loanId}`,opt,'POST');


//查看已分配的投资人
export const exclusiveUserApi = (opt) => fetch(`/mgt/loanaudit/query/exclusive/user?loanId=${opt.loanId}`,{},'GET');


//标的管理列表
export const loanmanageList = (opt) => {
        // let opt = opt2
        // opt.loanState=opt.loanState.length>0?opt.loanState.join(',')+',':''
        // opt.termCount=opt.termCount.length>0?opt.termCount.join(',')+',':''
        // opt.profit =opt.profit.length>0?opt.profit.join(',')+',':''
        // opt.loanType=opt.loanType.length>0?opt.loanType.join(',')+',':''
       return fetch(`/mgt/loanmanage/query/list`,opt,'GET');
}


//员工管理列表
export const getStaffListApi = (opt) => fetch(`/upms/staff/getStaffList`,opt,'GET');


//员工管理列表 新建
export const staffRegisterApi = (opt) => fetch(`/upms/staff/register?${joinStr(opt)}`,opt,'POST');


//员工管理列表 修改
export const roleUpdateRelationApi = (opt) => fetch(`/upms/role/updateRelation?${joinStr(opt)}`,opt,'POST');

//放标按钮
export const autoLendPayApi = (opt) => fetch(`/mgt/loan/autoLendPay?loanId=${opt.loanId}`,opt,'POST');


//新增权限树--->菜单(需要admin权限)
export const addTreeInfoByResourceApi = (opt) => fetch(`/upms/resource/addTreeInfoByResource?resourceName=${opt.resourceName}&url=${opt.url}&parentId=${opt.parentId}`,opt,'POST');

//新增权限树--->权限(需要admin权限)
export const addTreeInfoByPermissionApi = (opt) => fetch(`/upms/resource/addTreeInfoByPermission?permissionName=${opt.permissionName}&permission=${opt.permission}&resourceId=${opt.resourceId}`,opt,'POST');

//禁用/启用菜单(需要admin权限)
export const disableResourceApi = (opt) => fetch(`/upms/resource/disableResource?status=${opt.status}&resourceId=${opt.resourceId}`,opt,'POST');

//禁用/启用权限(需要admin权限)
export const disablePermissionApi = (opt) => fetch(`/upms/resource/disablePermission?status=${opt.status}&permissionId=${opt.permissionId}`,opt,'POST');

//获取角色以及角色对应的权限列表
export const getRoleListApi = (opt) => fetch(`/upms/role/getRoleList`,{},'GET');

//角色添加(需要admin权限)
export const addRoleApi = (opt) => fetch(`/upms/role/addRole?role=${opt.role}&roleName=${opt.roleName}&permissionIds=${opt.permissionIds}&resourceIds=${opt.resourceIds}`,opt,'POST');

//角色修改(需要admin权限)
export const updateRoleApi = (opt) => fetch(`/upms/role/updateRelation?${joinStr(opt)}`,opt,'POST');


//角色 禁用1 启用 0 
export const disableRoleApi = (opt) => fetch(`/upms/role/disableRole?${joinStr(opt)}`,opt,'POST');


//行业资讯列表
export const industryconsultancyListApi = (opt) => fetch(`/mgt/industryconsultancy/list?pageSize=${opt.pageSize}&pageNum=${opt.pageNum}&disable=${opt.disable}`,{},'GET');

//行业资讯添加
export const industryconsultancyAddApi = (opt) => fetch(`/mgt/industryconsultancy/add`,opt,'POST');


//行业资讯添加
export const industryconsultancyEditApi = (opt) => fetch(`/mgt/industryconsultancy/edit`,opt,'PUT');


//行业资讯删除
export const industryconsultancyDelApi = (opt) => fetch(`/mgt/industryconsultancy/delete?id=${opt.id}`,opt,'DELETE');




//公告列表
export const usernoticeListApi = (opt) => fetch(`/mgt/usernotice/list?pageSize=${opt.pageSize}&pageNum=${opt.pageNum}&disable=${opt.disable}`,{},'GET');

//公告添加 修改
export const usernoticeSaveApi = (opt) => fetch(`/mgt/usernotice/save`,opt,'POST');

//公告删除
export const usernoticeDelApi = (opt) => fetch(`/mgt/usernotice/delete?id=${opt.id}`,opt,'DELETE');

//excelExport管理
export const executionSqlTemplate = (opt) => fetch(`/mgt/operation/executionSqlTemplate`,opt,'GET');

//企业借款人添加
export const companyAdd = (opt) => fetch(`/mgt/company/add`,opt,'POST');

//发送催收短信
export const sendCollectionSMS = (opt) => fetch(`/mgt/send/msAndMail?${joinStr(opt)}`,opt,'POST');

//企业用户注册(因为数据库结构问题,单独预留此接口)
export const registryBank = (opt) => fetch(`/contract/bestSign/registryBank`,opt,'POST');

//个人绑卡关系查询
export const cardbindDetailApi = (opt) => fetch(`/mgt/credit2goaccount/cardbind/details`,opt,'GET');

//电子账户信息查询（按手机号查询存管子账号信息增强）
export const queryBymobileApi = (opt) => fetch(`/mgt/credit2goaccount/query/bymobile`,opt,'GET');

//企业账户查询
export const queryCorprationApi = (opt) => fetch(`/mgt/credit2goaccount/query/corpration`,opt,'GET');



//首页-借款人出借人数据
export const userInfoApi = (opt) => fetch(`/data/user/info`,opt,'GET');

//首页-当日新增数据
export const mainTodayDataApi = (opt) => fetch(`/mgt/main/todayData`,opt,'GET');




//首页-当日新增人数
export const dataCountApi = (opt) => fetch(`/mgt/main/dataCount`,opt,'GET');


//首页-当天意见反馈列表
export const userfeedbackApi = (opt) => fetch(`/mgt/userfeedback/list`,opt,'GET');


//首页-当天还款列表
export const repayOfDayApi = (opt) => fetch(`/mgt/repay/ofDay`,opt,'GET');



//运营管理-快捷银行管理 列表
export const bankcodeQueryListApi = (opt) => fetch(`/mgt/bankcode/query/list`,opt,'GET');


//运营管理-快捷银行管理 更新有效状态
export const bankcodeUpdateValidApi = (opt) => fetch(`/mgt/bankcode/update/valid?isValid=${opt.isValid}&bankCode=${opt.bankCode}`,opt,'PUT');

//运营管理-快捷银行管理 更新限额
export const bankcodeUpdateQuotaApi = (opt) => fetch(`/mgt/bankcode/update/quota?maxCountAmount=${opt.maxCountAmount}&maxDayAmount=${opt.maxDayAmount}&bankCode=${opt.bankCode}`,opt,'PUT');


//运营管理-优惠券模板列表
export const couponTemplateListApi = (opt) => fetch(`/mgt/coupon/query/template/list`,opt,'GET');

//运营管理-优惠券模板创建与修改
export const couponTemplateCreateAndUpdateApi = (opt) => fetch(`/mgt/coupon/save/template`,opt,'POST');

//运营管理-发放优惠券列表
export const queryUsercouponListApi = (opt) => fetch(`/mgt/coupon/query/usercoupon/list`,opt,'GET');

//运营管理-批量删除优惠券
export const removeUsercouponsApi = (opt) => fetch(`/mgt/coupon/remove/usercoupons?couponIds=${opt.couponIds}`,opt,'POST');

//运营管理-单个发送优惠券
export const sendcouponApi = (opt) => fetch(`/mgt/coupon/sendcoupon?${joinStr(opt)}`,opt,'POST');


// //运营管理-单个发送优惠券
// export const sendcouponApi = (opt) => fetch(`/mgt/coupon/sendcoupon?${joinStr(opt)}`,opt,'POST');



//运营管理-发送时选择模板列表时的信息
export const queryTemplatesInfoApi = (opt) => fetch(`/mgt/coupon/query/templates/info`,opt,'GET');

//运营管理-发送时选择礼包列表时的信息
export const queryBoxesInfoApi = (opt) => fetch(`/mgt/coupon/query/boxes/info`,opt,'GET');

//运营管理-礼包列表
export const boxListApi = (opt) => fetch(`/mgt/coupon/query/box/list`,opt,'GET');


//运营管理-还款管理列表
export const repayProfileApi = (opt) => fetch(`/mgt/repay/profile`,opt,'GET');


//运营管理-还款计划查询列表
export const repayPlanApi = (opt) => fetch(`/mgt/repay/plan`,opt,'GET');


//运营管理-还款计划查询列表 导出
export const repayPlanApiAxios = (opt) => ajax(`/mgt/repay/plan`,opt,'GET');


//运营管理-用户状态查询
export const userOrderTypeApi = (opt) => fetch(`/mgt/userOrder/type`,opt,'GET');


//运营管理-添加或修改礼包
export const couponUpdateBoxApi = (opt) => fetch(`/mgt/coupon/update/box`,opt,'POST');

//运营管理-删除礼包
export const couponRemoveBoxApi = (opt) => fetch(`/mgt/coupon/remove/box?${joinStr(opt)}`,opt,'POST');


//从礼包中移除模板
export const couponRemoveTemplateFromBoxApi = (opt) => fetch(`/mgt/coupon/remove/template/frombox?${joinStr(opt)}`,opt,'POST');



//运营管理-礼包内容里的列表
export const couponTemplateBoxListApi = (opt) => fetch(`/mgt/coupon/query/template/frombox`,opt,'GET');

//运营管理-向礼包中添加模板
export const addTemplateToBoxApi = (opt) => fetch(`/mgt/coupon/add/template/tobox?${joinStr(opt)}`,opt,'POST');


//运营管理-还款管理导出excel
export const profileExportExcelApi = (opt) => fetch(`/mgt/repay/profile/exportExcel`,opt,'GET');


//运营管理-还款管理导出excel ajax
export const profileExportExcelApiAjax = (opt) => ajax(`/mgt/repay/profile/exportExcel`,opt,'GET');


//运营管理-自选投列表
export const loanGroupListApi = (opt) => fetch(`/mgt/loanGroup/loanGroupList?${joinStr(opt)}`,opt,'POST');


//自选投通过自选投ID查询包含标的
export const getLoanListsByGroupIdApi = (opt) => fetch(`/mgt/loanGroup/getLoanListsByGroupId?${joinStr(opt)}`,opt,'POST');


//自选投未匹配列表接口
export const unmatchLoanListApi = (opt) => fetch(`/mgt/loanGroup/unmatch/loanList?${joinStr(opt)}`,opt,'POST');


//添加自选投标的
export const addLoanGroupApi = (opt) => fetch(`/mgt/loanGroup/addLoanGroup?${joinStr(opt)}`,opt,'POST');



//上传图片
export const borrowermaterialApi = (opt) => fetch(`/zuul/mgt/borrow/upload/borrowermaterial?financialId=${opt.financialId}&financialType=${opt.financialType}`,{file:opt.file},'POST');


//banner管理列表
export const bannerListApi = (opt) => fetch(`/mgt/banner/query/list`,opt,'GET');


//banner管理列表批量删除
export const bannerListBatchRemoveApi = (opt) => fetch(`/mgt/banner/batch/remove?${joinStr(opt)}`,opt,'POST');


//banner管理列表批量删除
export const bannerListCreateApi = (opt) => fetch(
        `/mgt/banner/upload?types=${opt.types}&showType=${opt.showType}&href=${opt.href}&publishTime=${opt.publishTime}&endTime=${opt.endTime}&description=${opt.description}&code=${opt.code}&code=${opt.actStartTime}&code=${opt.actEndTime}`
        ,{file:opt.file},'POST');


//用户积分排名接口 列表
export const recordRanksApi = (opt) => fetch(`/mall/backstage/record/ranks/${opt.pageNo}/${opt.pageSize}`,{mark:opt.mark},'GET');


//用户积分明细 列表
export const recordRecordsApi = (opt) => fetch(`/mall/backstage/record/records/${opt.pageNo}/${opt.pageSize}`,{userId:opt.userId,type:opt.type},'GET');

//商品管理 列表
export const pageGoodsApi = (opt) => fetch(`/mall/goods/page/goods`,opt,'GET');

//商品管理 列表 设置热门商品
export const popularGoodsApi = (opt) => fetch(`/mall/backstage/goods/goods/popular?id=${opt.id}`,{},'PUT');


//商品管理 添加商品
export const createGoodsApi = (opt) => fetch(`/mall/backstage/goods/goods?${joinStr(opt)}`,{},'POST');
//商品管理 添加商品
export const updateGoodsApi = (opt) => fetch(`/mall/backstage/goods/goods?${joinStr(opt)}`,{},'PUT');

//商品管理 获取商品详情
export const getGoodsApi = (opt) => fetch(`/mall/backstage/goods/goods?${joinStr(opt)}`,{},'GET');


//商品管理 删除商品
export const removeGoodsApi = (opt) => fetch(`/mall/backstage/goods/goods?${joinStr(opt)}`,{},'DELETE');

//商品兑换记录 
export const orderRecordsApi = (opt) => fetch(`/mall/backstage/order/${opt.pageNo}/${opt.pageSize}`,{type:opt.type,goodsName:opt.goodsName,mark:opt.mark},'GET');


//提现开关 
export const forbidStatusApi = (opt) => fetch(`/mgt/user/update/forbidStatus?${joinStr(opt)}`,opt,'POST');

//投资开关 
export const investLevelApi = (opt) => fetch(`/mgt/user/update/investLevel?${joinStr(opt)}`,opt,'POST');


//修改订单状态
//export const putOrderStatusApi = (opt) => fetch(`/app/backstage/order/${opt.orderId}`,{thirdOrderId:opt.thirdOrderId,thirdCompany:opt.thirdCompany},'PUT');


//提前还款确认 
export const loanPrepaymentApi = (opt) => fetch(`/job/general/loanPrepayment`,opt,'GET');

//提前还款撤回
export const loanPrepaymentReturnApi = (opt) => fetch(`/job/general/loanPrepaymentReturned`,opt,'GET');

//征信查询
export const creditQueryApi = (opt) => fetch(`/mgt/credit/query`,opt,'GET');

//安融征信查询
export const anrongcreditQueryApi = (opt) => fetch(`/mgt/anrong/query`,opt,'GET');

//征信pdf下载
export const creditDownloadApi = (opt) => fetch(`/mgt/credit/downLoad`,opt,'GET');


//渠道管理列表
export const invitationCodeApi = (opt) => fetch(`/mgt/invitation/get/invitationCode`,opt,'GET');
//渠道管理列表修改渠道
export const eventIdApi = (opt) => fetch(`/mgt/user/update/eventId?${joinStr(opt)}`,opt,'POST');


//合同url
export const contractFileUrlApi = (opt) => fetch(`/contract/file/url`,opt,'GET');


//征信授权
export const contractCreditUrlApi = (opt) => fetch(`/contract/credit/url`,opt,'GET');


//合同下载
export const getContractStreamApi = (opt) => ajax(`/contract/bestSign/getContractStream`,opt,'GET');

//投标申请撤销
export const bidCancelApi = (opt) => fetch(`/mgt/credit2gocreditrights/bidCancel?${joinStr(opt)}`,opt,'POST');

//投资人债权明细查询
export const creditDetailsApi = (opt) => fetch(`/mgt/credit2gocreditrights/credit/details`,opt,'GET');

//红包发放
export const voucherpayApi = (opt) => fetch(`/mgt/credit2gotransfer/voucherpay?${joinStr(opt)}`,opt,'POST');


//电子账户查询
export const credit2goaccountBalanceApi = (opt) => fetch(`/mgt/credit2goaccount/balance`,opt,'GET');

//投资人投标申请查询
export const credit2goaccountBidapplyApi = (opt) => fetch(`/mgt/credit2goaccount/bidapply`,opt,'GET');


//通过标ID查询投资人投标申请
export const credit2goaccountBidapplysApi = (opt) => fetch(`/mgt/credit2goaccount/bidapplys`,opt,'GET');


//批次交易明细状态查询
export const batchdetailsApi = (opt) => fetch(`/mgt/credit2goaccount/batchdetails`,opt,'GET');


//批次发红包交易明细状态查询
export const batchvoucherDetailsApi = (opt) => fetch(`/mgt/credit2goaccount/batchvoucher/details`,opt,'GET');


//电子账户资金交易明细查询
export const transdetailApi = (opt) => fetch(`/mgt/credit2goaccount/transdetail`,opt,'GET');


//流水查询
export const capitalListApi = (opt) => fetch(`/mgt/capital/list`,opt,'GET');


//资金流水全部
export const capitalAllListApi = (opt) => fetch(`/mgt/capital/all/list`,opt,'GET');
//资金流水类型
export const capitalMenuApi = (opt) => fetch(`/mgt/capital/types`,opt,'GET');



//活动列表
export const actListApi = (opt) => fetch(`/act/backstage/act`,opt,'GET');
//奖品池
export const actPoolApi = (opt) => fetch(`/act/backstage/pool`,opt,'GET');

//活动记录
export const actRecordsApi = (opt) => fetch(`/act/backstage/records/${opt.pageNum}/${opt.pageSize}`,opt,'GET');



//信息核验
export const ivProductApi = (opt) => fetch(`/mgt/baihang/ivProduct`,opt,'GET');


//特别关注名单
export const sfProductApi = (opt) => fetch(`/mgt/baihang/sfProduct`,opt,'GET');


//员工管理启用禁用
export const updateStatusApi = (opt) => fetch(`/upms/staff/updateStatus?${joinStr(opt)}`,opt,'POST');

//用户管理修改
export const staffUpdateApi = (opt) => fetch(`/upms/staff/update?${joinStr(opt)}`,opt,'POST');




//反欺诈
export const afProductApi = (opt) => fetch(`/mgt/baihang/afProduct`,opt,'GET');


//邀请返现审核 确认
export const transactionApi = (opt) => fetch(`/mgt/invitation/transaction`,opt,'GET');


//邀请返现审核 通过
export const transactionPassApi = (opt) => fetch(`/mgt/invitation/pass?${joinStr(opt)}`,opt,'POST');


//邀请返现确认打款
export const transactionTransferApi = (opt) => fetch(`/mgt/invitation/transfer?${joinStr(opt)}`,opt,'POST');

//宝付列表
export const baofuListApi = (opt) => fetch(`/mgt/loanmanage/query/baofu/toReleaseLoan`,opt,'GET');


//虚标已创建列表
export const recombinedListApi = (opt) => fetch(`/mgt/loanVipRedeem/recombined/list`,opt,'GET');

//虚标待创建列表
export const unRecombinedListApi = (opt) => fetch(`/mgt/loanVipRedeem/unRecombined/list`,opt,'GET');


//创建虚标
export const recombineCreateApi = (opt) => fetch(`/mgt/loanVipRedeem/recombine?${joinStr(opt)}`,opt,'POST');


//宝付 放款
export const baofooBF0040001Api = (opt) => fetch(`/mgt/baofoo/BF0040001?${joinStr(opt)}`,opt,'POST');



//站内信查询
export const innerMailListApi = (opt) => fetch(`/mgt/innerMail/list`,opt,'GET');

//短信查询
export const userSmsMailListApi = (opt) => fetch(`/mgt/user/sms/list`,opt,'GET');



//登录账户解锁
export const loginUnlockApi = (opt) => fetch(`/mgt/user/login/unlock?${joinStr(opt)}`,opt,'POST');
export const joinStr = (data)=>{
        let dataStr = ''; //数据拼接字符串
        Object.keys(data).forEach(key => {
            dataStr += key + '=' + data[key] + '&';
        })
        return dataStr.substr(dataStr,dataStr.length-1)
}




// WEBPACK FOOTER //
// ./src/service/getData.js